
  import { mapState } from 'vuex'
  import commonUtils from '~/mixins/pages/mission-control/commonUtils'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme2MissionMobileVipPrivilegePage',
    mixins: [vipSettings, commonUtils],
    data() {
      return {
        displayTermAndConditionModal: false,
        claimLevelUpLoading: {},
        claimBirthdayLoading: {},
        displayClaimSuccessModal: false,
        loadingPage: true
      }
    },
    computed: {
      ...mapState({
        vipTiers: state => state.activities['vip-system'].vipTiers,
        vipSystem: state => state.activities['vip-system'].vipSystem,
        vipSystemLoading: state => state.activities['vip-system'].vipSystemLoading,
        vipTiersLoading: state => state.activities['vip-system'].vipTiersLoading,
        player: state => state.player.player,
        defaultCurrency: state => state.settings.defaultCurrency
      }),
      tiersList() {
        if (this.vipTiers?.tiers?.length)
          return this.vipTiers.tiers?.filter(el => el.tier_type === 1)
        return []
      },
      getTierProgress() {
        return item => {
          const totalAmount = parseFloat(this.vipTiers?.player?.total_amount)
          const minRange = parseFloat(item.min_range)
          const maxRange = parseFloat(item.max_range)
          const obj = {
            is_done: false,
            progress: 0
          }
          if (totalAmount >= minRange && totalAmount < maxRange) {
            obj.is_done = true
            obj.progress = ((totalAmount - minRange) / (maxRange - minRange)) * 100
          } else if (totalAmount >= maxRange) {
            obj.is_done = true
            obj.progress = 100
          }
          return obj
        }
      },
      isActiveCard() {
        return item => {
          if (!this.$cookie.get('token')) return ''
          const totalAmount = parseFloat(this.vipTiers?.player?.total_amount)
          const minRange = parseFloat(item.min_range)
          const maxRange = parseFloat(item.max_range)
          if (totalAmount >= minRange && totalAmount < maxRange) {
            return 'tier-card-active'
          }
          return ''
        }
      }
    },
    mounted() {
      this.$store.dispatch('activities/vip-system/getVipTiers', {
        currency: this.defaultCurrency
      })
      this.$store.dispatch('activities/vip-system/getVipSettings', {
        currency: this.defaultCurrency
      })
    },
    methods: {
      async claimReward(tierId, type = 'level_up') {
        let claimStoreActionPath = 'activities/vip-system/claimLevelUpReward'
        if (type !== 'level_up') {
          this.claimBirthdayLoading = {
            ...this.claimBirthdayLoading,
            [tierId]: true
          }
          claimStoreActionPath = 'activities/vip-system/claimBirthdayReward'
        } else {
          this.claimLevelUpLoading = {
            ...this.claimLevelUpLoading,
            [tierId]: true
          }
        }
        const response = await this.$store.dispatch(claimStoreActionPath, tierId)
        if (response) {
          this.loadingPage = false
          await this.$store.dispatch('activities/vip-system/getVipTiers')
          this.loadingPage = true
          this.onDisplayClaimSuccessModal()
        }
        if (type !== 'level_up') {
          this.claimBirthdayLoading[tierId] = false
        } else {
          this.claimLevelUpLoading[tierId] = false
        }
      },
      onDisplayClaimSuccessModal() {
        this.displayClaimSuccessModal = true
        setTimeout(() => {
          this.displayClaimSuccessModal = false
        }, 3000)
      }
    }
  }
